// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttons-wrapper{display:flex;justify-content:flex-end;margin-top:30px}", "",{"version":3,"sources":["webpack://src/components/participants/edit-modal/edit-participant-modal.scss"],"names":[],"mappings":"AAAA,iBACE,YAAA,CACA,wBAAA,CACA,eAAA","sourcesContent":[".buttons-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
